import { Tabs, TabsProps } from 'antd';
import styled from 'styled-components';
import { CALLER_COLORS as C } from './tokens';

const renderTabBar = () => <></>;

type Props = {
  items: TabsProps['items'];
  value?: TabsProps['activeKey'];
  onChange?: TabsProps['onChange'];
};
const TabNavigators = ({ items, onChange, value }: Props) => {
  return (
    <TabsStyled className='tab-navigators' activeKey={value} onChange={onChange} defaultActiveKey="caller-list" items={items} renderTabBar={renderTabBar} />
  );
};

export default TabNavigators;

// Fill the available height so each tabpane is height-bounded — lets the active
// tab scroll internally (header fixed, detail footer pinned).
const TabsStyled = styled(Tabs)`
  &.tab-navigators {
    flex: 1 1 auto;
    min-height: 0;
  }
  &.tab-navigators .ant-tabs-content-holder {
    flex: 1 1 auto;
    min-height: 0;
  }
  &.tab-navigators .ant-tabs-content {
    height: 100%;
  }
  &.tab-navigators .ant-tabs-content-holder .ant-tabs-content .ant-tabs-tabpane {
    height: 100%;
    padding: 0;
    background: ${C.panelBg};
  }
`;